export default "__VITE_ASSET__CsuZT5vv__"